import { render } from "./TeamEdit.vue?vue&type=template&id=4f3ee358&scoped=true"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"

import "./TeamEdit.vue?vue&type=style&index=0&id=4f3ee358&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3ee358"]])

export default __exports__